/* This file was auto generated by "illustrations-tool" */
import { DEV } from 'esm-env';
import createSvgIllustration from '../createSvgIllustration';
export default createSvgIllustration(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={360}
    height={296}
    fill="none"
    viewBox="0 0 360 296"
  >
    <path
      fill="#EBF1FE"
      d="M-59 110.3c-1.4 261.5 343.3 192.9 419.4 117.2 45.7-33.8 106-143.4-18-311.4-155-210-400-67.2-401.4 194.2"
      className="bg"
      opacity={0.6}
    />
  </svg>,
  DEV ? 'BlobIllustration' : '',
);
